import { Collapse } from "antd";
import styled from "styled-components";

export const StyledAccordion = styled(Collapse)<{ level: number }>`
    border: none;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .ant-collapse-item {
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    }

    .ant-collapse-header {
        padding: 0 0 ${({ level = 1 }) => 14 - level * 2}px 0 !important;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .ant-collapse-content {
        border-color: ${({ theme }) => theme.secondaryBorderColor};
    }

    .ant-collapse-content-box {
        padding: 12px 0px 12px 24px !important;
        background-color: ${(props) =>
            props.theme.collapseHeaderBackground} !important;
    }

    max-width: ${({ level = 1 }) => 100 - level * 2}%;
    margin-left: ${({ level = 1 }) => (level > 1 ? "auto" : "0")};
`;

export const StyledAPHistoryPaymentsRowWrapper = styled.div`
    padding-bottom: 8px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledAPHistoryPayments = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledAPHistoryPaymentsRowBottom = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;
`;

export const StyledAPHistoryPaymentsRowBottomLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StyledAPHistoryPaymentsRowBottomRight = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StyledAPHistoryPaymentsRowBottomBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const StyledAPHistoryProducts = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledAPHistoryProductTableRowWrapper = styled.div`
    padding-bottom: 8px;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledAPHistoryProductTableRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
`;

export const StyledAPHistoryProductTableRowBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const StyledHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
`;

export const StyledHeaderBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const StyledHistoryContainer = styled.div`
    padding: 16px 16px 0 16px;
    width: 100%;
    background: ${({ theme }) => theme.secondaryBackgroundColor};
    border-radius: 10px;
`;

export const StyledPrice = styled.h4`
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: ${({ theme }) => theme.additionalTypographyColor};
    text-align: right;
    white-space: nowrap;
    margin: 0;
`;
